import io from 'socket.io-client';
import _ from 'lodash';
import { addSocketUser } from '../actions/socketActions';
import { GET_USERS_LIST, SOCKET_CONNECT, SOCKET_DISCONNECT } from '../actions/types';
import { serverUrl } from '../global/Environment';
import * as Sentry from '@sentry/browser';
import { userApi } from '../api/userApi';
import { selectedUserIdSelector } from '../selectors/userSelectors';
import { TAGS } from '../api/baseApi';

export const createSocketMiddleware = () => (store) => {
  let socket = null;

  return (next) => (action) => {
    switch (action.type) {
      case SOCKET_CONNECT:
        if (socket) {
          socket.disconnect();
        }
        socket = createSocket(store);
        return;
      case SOCKET_DISCONNECT:
        if (socket) {
          socket.disconnect();
        }
        socket = null;
        return;
      // Join socket rooms when the user list in SideMenu is updated
      case GET_USERS_LIST:
        if (socket) {
          socket.emit('set chat rooms', _.map(action.payload, 'userId'));
        }
        return next(action);
      default:
        return next(action);
    }
  };
};

export const createSocket = (store) => {
  const socket = io(`${serverUrl()}webops`, {
    transports: ['websocket'],
    auth: (cb) => {
      cb({
        token: localStorage.getItem('KeeperToken')
      });
    }
  });

  socket.io.on('open', () => {
    console.log(`${new Date()}: socket connecting`);
    socket.emit('set chat rooms', _.map(store.getState().user.userList, 'userId'));
  });

  socket.io.on('error', (e) => {
    console.error('socket encountered error: ', e.message, 'Closing socket');
    socket.close();
  });

  socket.io.on('close', (reason) => {
    console.log(`${new Date()}: socket disconnected -- ${reason}`);
  });

  socket.on('connect_error', (error) => {
    console.error('There was an error connecting the socket: ', error.message);
    Sentry.captureException(error);
  });

  socket.on('message', async (action) => {
    const selectedUserId = selectedUserIdSelector(store.getState());

    if (action.type === 'SEND_MESSAGE') {
      const payload = _.get(action, 'payload');
      const messageUserId = _.get(payload, 'user_id');

      if (messageUserId === selectedUserId) {
        const userInfo = selectedUserId
          ? (await store.dispatch(userApi.endpoints.getUserInfo.initiate(selectedUserId))).data
          : {};
        const unifiedChatEnabled = _.get(userInfo, 'unifiedChatEnabled');
        const isUserMessage = _.isNil(payload?.bookkeeper);
        const isEscalationMessage = payload.textType === 'notification - escalation';

        if (unifiedChatEnabled) {
          if (isUserMessage && isEscalationMessage) {
            store.dispatch(addSocketUser(messageUserId));
          }
        } else if (isUserMessage) {
          store.dispatch(addSocketUser(messageUserId));
        }
        store.dispatch(
          userApi.util.invalidateTags([TAGS.USER_INFO, TAGS.USER_MESSAGES, TAGS.USER_BOOKKEEPER_ASSIGNMENTS])
        );
      }
    }
    if (action.type === 'USER_ESCALATED') {
      store.dispatch(userApi.util.invalidateTags([TAGS.USER_LIST, TAGS.UNNOTICED_USERS, TAGS.NUM_BLUE_DOTS]));
    }
    if (action.type === 'REMINDER_SENT') {
      const payload = _.get(action, 'payload');
      const reminderUserId = _.get(payload, 'user_id');
      if (reminderUserId === selectedUserId) {
        store.dispatch(userApi.util.invalidateTags([TAGS.USER_REMINDERS, TAGS.USER_BOOKKEEPER_ASSIGNMENTS]));
      }
    }
  });

  return socket;
};
